var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-real-test-start" }, [
    _c("i", {
      staticClass: "iconfont iconfanhui",
      staticStyle: {
        "font-size": "30px",
        position: "absolute",
        margin: "10px 0 0 20px",
      },
      on: {
        click: function ($event) {
          return _vm.$router.go(-1)
        },
      },
    }),
    _c("div", { staticClass: "container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.dataText.title ? _vm.dataText.title : "考前模拟")),
      ]),
      _c("div", { staticClass: "real-content" }, [
        _c("div", { staticClass: "img-box" }),
        _c("div", { staticStyle: { flex: "1" } }, [
          _c("div", { staticClass: "test-info" }, [
            _c("p", { staticClass: "row" }, [
              _c("span", [
                _vm._v(" 考试总时长： "),
                _c(
                  "em",
                  {
                    staticClass: "primary",
                    staticStyle: { "font-style": "normal" },
                  },
                  [_vm._v(_vm._s(_vm.dataText.duration) + "分钟")]
                ),
              ]),
              _c("span", [
                _vm._v("共计：" + _vm._s(_vm.dataText.question_num) + "道题"),
              ]),
            ]),
            _c("p", { staticClass: "row" }, [
              _c("span", [
                _vm._v("总分：" + _vm._s(_vm.dataText.total_score) + "分"),
              ]),
              _c("span", [
                _vm._v("合格分：" + _vm._s(_vm.dataText.pass_score) + "分"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "test-notice" }, [
            _c("p", { staticClass: "tit" }, [_vm._v("题型介绍：")]),
            _c("div", { staticStyle: { "white-space": "pre-line" } }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.dataText.introduction) },
              }),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "pab20", staticStyle: { "text-align": "center" } },
        [
          _vm.type == 3
            ? _c(
                "el-button",
                {
                  staticClass: "start-btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.startExam(0)
                    },
                  },
                },
                [_vm._v("开始练习")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              staticClass: "start-btn",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.startExam(1)
                },
              },
            },
            [_vm._v("开始考试")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }